export var AndroidProductType;
(function (AndroidProductType) {
    AndroidProductType["SUBS"] = "subs";
    AndroidProductType["INAPP"] = "inapp";
})(AndroidProductType || (AndroidProductType = {}));
//# sourceMappingURL=definitions.js.map